export default __webpack_public_path__ + "static/media/congratulations.2d7f59b3.svg";